import { TextField as TextFieldWrapper, styled } from '@mui/material';
import React, { FC } from 'react';

// Кастомный стиль инпута телефона
const CssTextField = styled(TextFieldWrapper)({
  '& label.Mui-focused': {
    color: '#949494',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'green',
  },
  '& .MuiInputBase-root': {
    '& .MuiInputBase-input': {
      fontSize: '16px !important',
      fontFamily: 'Open Sans, sans-serif',
      fontWeight: '400 !important',
      lineHeight: '22px !important',
    },
  },
});

interface FormFieldProps {
  onChangeValue: (value: string) => void;
  value?: string;
  name: string;
  label: string;
  className?: string;
  required?: boolean;
  edit?: boolean;
}

// Инпут оформления заказа
export const CheckoutPhoneField: FC<FormFieldProps> = ({
  onChangeValue,
  value,
  name,
  label,
  className,
  required,
  edit,
}) => {
  return (
    <CssTextField
      onChange={(e: any) => onChangeValue(e.target.value)}
      value={value}
      className={
        className ? `${className}` : 'Checkout_div_left_part1_contact__inp'
      }
      required={required ? required : false}
      name={name}
      label={label}
      size="small"
      color="info"
      variant="outlined"
      fullWidth
    />
  );
};
